module.exports = __webpack_public_path__ + "media/img/corporate/logos/apple-cf194d58e731f1496de9cea99abda0e0.svg";